
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import reduxStore from './../../../../../reduxStore';
import { Link } from 'react-router';

import utils from './../../../../../utils/utilities';
import xhr from './../../../../../utils/xhr';

import LightSpinnerWrapper from './../../../../../reusable/Wrappers/LightSpinnerWrapper/LightSpinnerWrapper.jsx';
import ContentPod from './../../../../../reusable/ContentPod/ContentPod.jsx'
import {
    EXPERIAN_RISK_HIGH,
    EXPERIAN_RISK_LOW,
    EXPERIAN_RISK_LOW_MEDIUM,
    EXPERIAN_RISK_MEDIUM,
    EXPERIAN_RISK_MEDIUM_HIGH,
    EXPERIAN_RISK_VERY_HIGH
} from '../../../../../constants';
import storage from "../../../../../utils/storage";

const riskMap = {
    'LOW_RISK': <FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.lowRisk"/>,
    'LOW_MEDIUM_RISK': <FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.lowMediumRisk"/>,
    'MEDIUM_RISK': <FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.mediumRisk"/>,
    'MEDIUM_HIGH_RISK': <FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.mediumHighRisk"/>,
    'HIGH_RISK': <FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.highRisk"/>,
    'VERY_HIGH_RISK': <FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.veryHighRisk"/>
}

class EntityExperian extends React.Component {

    static propTypes = {
        companyId: PropTypes.string,
        experianData: PropTypes.object,
        companyData: PropTypes.object
    }

    constructor(props) {
        super(props);
        this.user = reduxStore.getState().user;
    }

    render() {
        let isDossieEnabled = this.user.appSettings.isDossierEnabled;

        return (
            <div className="entity-experian_dashboard">
                {this.user.appSettings.isExperianEnabled && this.props.experianData
                    && this.props.experianData.experianResponse && this.props.experianData.experianResponse.success &&
                <ContentPod
                    title={<FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.experianScore"/>}
                    collapsed={false}
                    className={"experian-score-wrapper"}>
                    <LightSpinnerWrapper isLoading={!this.props.experianData}>
                        <div className="experian-pod-content">
                            {(this.props.experianData && this.props.experianData.experianResponse.success) ? (
                                <div className="experian-bubbles">
                                    <div className="experian-score">
                                        <div className="experian-score__item">
                                            <div className="experian-score__title">
                                                <FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.delinquencyRisk" />
                                            </div>
                                            <div className={"experian-score__bubble " + getRiskClass(this.props.experianData.experianRatings.financial.risk)}>
                                                <div className="experian-score__level">
                                                    {riskMap[this.props.experianData.experianRatings.delinquency.risk]}
                                                </div>
                                            </div>
                                            <div className={"experian-score__trend " + getTrendingClass(this.props.experianData.experianRatings.delinquency.trend)}>
                                                {getTrendingClass(this.props.experianData.experianRatings.delinquency.trend) ?
                                                    getTrendingClass(this.props.experianData.experianRatings.delinquency.trend) :
                                                    <FormattedMessage id="General_CoreFunctionality_UIText_general.notAvailableShort"/>}
                                            </div>
                                        </div>
                                        <div className="experian-score__item">
                                            <div className="experian-score__title">
                                                <FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.stabilityRisk" />
                                            </div>
                                            <div className={"experian-score__bubble " + getRiskClass(this.props.experianData.experianRatings.financial.risk)}>
                                                <div className="experian-score__level">
                                                    {riskMap[this.props.experianData.experianRatings.financial.risk]}
                                                </div>
                                            </div>
                                            <div className={"experian-score__trend " + getTrendingClass(this.props.experianData.experianRatings.financial.trend)}>
                                                {getTrendingClass(this.props.experianData.experianRatings.financial.trend) ?
                                                    getTrendingClass(this.props.experianData.experianRatings.financial.trend) :
                                                    <FormattedMessage id="General_CoreFunctionality_UIText_general.notAvailableShort"/>}
                                            </div>
                                        </div>
                                        <div className="experian-score__item">
                                            <div className="experian-score__title">
                                                <FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.bankruptcyFiled" />
                                            </div>
                                            <div className={"experian-score__bubble " +
                                            (this.props.experianData.experianRatings.bankruptcy ? "high-risk" : "low-risk")}>
                                                <div className="experian-score__level">
                                                    {
                                                        this.props.experianData.experianRatings.bankruptcy ?
                                                            <FormattedMessage
                                                                id='General_CoreFunctionality_UIText_general.yes' /> :
                                                            <FormattedMessage
                                                                id='General_CoreFunctionality_UIText_general.no' />
                                                    }
                                                </div>
                                            </div>
                                            <div className={"experian-score__trend"}>
                                                <FormattedMessage id="General_CoreFunctionality_UIText_general.notAvailableShort"/>
                                            </div>
                                        </div>
                                    </div>
                                    {this.props.experianData && this.props.experianData.experianResponse.success && (
                                        <Link to={"/view-experian/" + this.props.companyId + "/" + this.props.companyData.experianBusinessId}
                                            className="experian-full-doc-link action-link">
                                            <FormattedMessage id="Dashboard_CoreFunctionality_UIText_experian.viewFullDocument"/>
                                        </Link>
                                    )}
                                </div>
                        ) : (
                                <div className="no-experian-info">
                                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_EXPERIAN_BUSINESS_ID_INVALID_FORMAT"/>
                                </div>
                            )}
                        </div>
                    </LightSpinnerWrapper>
                </ContentPod> }
            </div>
        );
    }

}

function getRiskClass(risk) {
    const risks = {
        [EXPERIAN_RISK_VERY_HIGH]:   "very-high-risk",
        [EXPERIAN_RISK_HIGH]:        "high-risk",
        [EXPERIAN_RISK_MEDIUM_HIGH]: "medium-high-risk",
        [EXPERIAN_RISK_MEDIUM]:      "medium-risk",
        [EXPERIAN_RISK_LOW_MEDIUM]:  "low-medium-risk",
        [EXPERIAN_RISK_LOW]:         "low-risk",
        "UNDEFINED":                 null
    };
    return risks[risk];
}

function getTrendingClass(trend) {
    const trends = {
        "POSITIVE":  "Positive",
        "NEGATIVE":  "Negative",
        "POSITIVE_ES":  "Positive",
        "NEGATIVE_ES":  "Negative",
        "UNDEFINED": null
    };
    return trends[trend];
}

export default EntityExperian;


// WEBPACK FOOTER //
// ./src/scripts/pages/EntityDashboard/components/AboutThisEntity/components/EntityExperian.jsx